import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "header" }
const _hoisted_4 = { class: "name" }
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("h2", _hoisted_1, _toDisplayString(_ctx.$t('cv.science')), 1),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sp, (proj) => {
        return (_openBlock(), _createElementBlock("article", {
          key: proj.name
        }, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("span", {
                innerHTML: proj.name
              }, null, 8, _hoisted_5),
              (proj.label)
                ? (_openBlock(), _createElementBlock("span", {
                    key: 0,
                    innerHTML: proj.label.text,
                    class: "label",
                    style: _normalizeStyle({ backgroundColor: proj.label.color })
                  }, null, 12, _hoisted_6))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", {
              class: "year",
              innerHTML: proj.time
            }, null, 8, _hoisted_7)
          ]),
          _createElementVNode("div", {
            class: "desc",
            innerHTML: proj.description
          }, null, 8, _hoisted_8)
        ]))
      }), 128))
    ])
  ], 64))
}